<his-search-result
    #searchResultComponent
    [isSearchFormResult]="true"
    tableTitle = "cs.psv.person.idAssignment.orcid.search.results.header"
    [showTitle]="true"
    [showNewSearchButton]="false"
    [showChangeSearchButton]="false"
    idColumn="PersonOrcidImportItem.orcid"
    defaultColumn="PersonOrcidImportItem.orcid"
    defaultActionUrl="https://orcid.org/:id"
    defaultActionToolTip="cs.psv.person.idAssignment.orcid.openprofile"
    [hisIcon]="'arrow_right'"
    [selectionSetting]="selectionSetting.MultiSelect">
    <ng-container customResultButtons>
        <ng-container
            *ngTemplateOutlet="buttonsTemplate; context: {search: searchResultComponent.search}">
        </ng-container>
    </ng-container>
</his-search-result>
<ng-container
    *ngTemplateOutlet="buttonsTemplate; context: {search: searchResultComponent.search}">
</ng-container>
<br/><br/>
<ng-template #buttonsTemplate let-search="search">
    <button type="submit" iconPos="left" (click)="onNewSearch()">
        <span>{{'de.his.javang.newsearch'|hisUi}}</span>
    </button>
    <button type="submit" iconPos="left" (click)="onChangeSearch()">
        <span>{{'de.his.javang.changesearch'|hisUi}}</span>
    </button>
    <button [disabled]="!searchResultComponent?.rows.length" (click)="onDoImport()" hisImage="LINE_OUT" class="transparent"><span>{{'cs.psv.person.idAssignment.orcid.search.results.button.importStart' | hisUi}}</span></button>
</ng-template>
